import pure from "./higher-order/pure";
import React from "react";
import SurvivorGraph from "./survivor-graph";
import TicketTable from "./ticket-table";

export default pure(function SurvivorOverview({ number, survivors, tournament, users }) {
  var total = tournament.get("tickets").count();
  var numSurvivors = survivors.get(number - 1).count();
  var eliminated = total - numSurvivors;
  if (number > 1) {
    eliminated = survivors.get(number - 2).count() - numSurvivors;
  }

  var raceSurvivors = survivors.get(number - 1);

  return (
    <div className="popup">
      <div className="popup_content">
        <div className="popup_title">
          {numSurvivors}

          {" "}
          survivors &amp;

          {eliminated}

          {" "}
          players eliminated.
        </div>

        <div className="popup_body">
          <h3 className="color--is-lime">
            Survivors
          </h3>

          <TicketTable tickets={raceSurvivors} users={users} />
        </div>
      </div>

      <div className="survivor-stats">
        <SurvivorGraph eliminated={eliminated} survivors={numSurvivors} total={total} />
      </div>
    </div>
  );
});
